import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { CodeModel } from 'src/models/common-code/CommonCode';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Popup
 *
 * Popup을 설명하세요.
 */
export const Popup = types
  .model('Partner')
  .props({
    popupSid: types.number, // 팝업 sid
    langCd: types.optional(types.string, 'ko'), // 언어
    title: types.string, // 팝업 제목
    descript: types.optional(types.string, ''), // 설명
    useYn: types.optional(types.boolean, false), // 사용 여부
    delYn: types.optional(types.boolean, false), // 삭제 여부
    startDt: types.optional(types.number, 0), // 시작일
    endDt: types.optional(types.number, 0), // 종료일
    width: types.optional(types.maybeNull(types.number), 0), // 너비
    height: types.optional(types.maybeNull(types.number), 0), // 높이
    popupEnvCd: types.optional(CodeModel, { code: 101401, pcode: 1014, value: 'WEB' }), // 노출환경
    inactiveTime: types.optional(types.number, 24), // 비활성화 시간
    topPosition: types.optional(types.number, 0), // 상단위치
    leftPosition: types.optional(types.number, 0), // 좌측위치
    regUser: types.maybeNull(OperatorInfo), // 등록자
    updUser: types.maybeNull(OperatorInfo), // 수정자
    regDt: types.optional(types.maybeNull(types.number), 0), // 등록일
    updDt: types.optional(types.maybeNull(types.number), 0), // 수정일
  })
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TPopup = Instance<typeof Popup>;
type TPopupSnapshot = SnapshotOut<typeof Popup>;

export interface IPopup extends TPopup {}
export type TPopupKeys = keyof TPopupSnapshot & string;
export interface IPopupSnapshot extends TPopupSnapshot {}
export const createPopup = () => types.optional(Popup, {} as TPopup);
